import React, { useEffect, useState } from "react";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "connecther_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const choice = localStorage.getItem(STORAGE_KEY);
    if (!choice) setVisible(true);
  }, []);

  function record(value) {
    localStorage.setItem(STORAGE_KEY, value);
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-[60] bg-navy text-soft rounded-2xl shadow-cardHover p-5 md:p-6 border border-soft/10"
    >
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 rounded-xl bg-gold/15 text-gold flex items-center justify-center flex-shrink-0">
          <Cookie className="w-5 h-5" />
        </div>
        <div className="flex-1 text-sm text-soft/85 leading-relaxed">
          <div className="font-serif text-soft text-base mb-1">
            We value your privacy
          </div>
          <p>
            We use cookies to improve your experience, analyze traffic, and
            personalize content. By clicking &quot;Accept&quot;, you agree to our use of
            cookies.
          </p>
          <div className="mt-4 flex flex-wrap gap-2">
            <button
              onClick={() => record("accepted")}
              data-testid="cookie-accept"
              className="bg-gold text-navy hover:bg-gold/90 transition-colors rounded-full px-5 py-2 text-xs font-medium uppercase tracking-wider"
            >
              Accept
            </button>
            <button
              onClick={() => record("rejected")}
              data-testid="cookie-reject"
              className="bg-transparent border border-soft/30 text-soft hover:bg-soft/10 transition-colors rounded-full px-5 py-2 text-xs font-medium uppercase tracking-wider"
            >
              Decline
            </button>
          </div>
        </div>
        <button
          onClick={() => record("dismissed")}
          aria-label="Dismiss"
          data-testid="cookie-dismiss"
          className="text-soft/40 hover:text-soft transition"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
